// extracted by mini-css-extract-plugin
module.exports = {"tokenInfo_data":"style_tokenInfo_data__so-v5"};